// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Customer } from './customer';
import { Invoice } from './invoice';
import { Payment } from './payment';
import { QuickBooksTask } from './quick-books-task';
import { Vendor } from './vendor';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class QuickBooksTaskResponse extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get type() {
        let type = '';
        // if (this.customerId) type = 'Customer';
        // else if (this.invoiceId) type = 'Invoice';
        // else if (this.vendorId) type = 'Vendor';
        // else if (this.paymentId) type = 'Payment';
        // else if (this.message.indexOf('Account') !== -1) type = 'Account';
        // else type = 'QBProductService'
        // return type;
        return this.quickBooksTask.type;
    }

    get customerName() {
        let customerName = '';

        if (this.type === 'Customer') {
            customerName = this.customer.displayName;
        } else if ((this.type === 'Invoice' || this.type === 'Credit') && !!this.invoice) {
            customerName = this.invoice.customer?.displayName;
        } else if (this.type === 'Payment' && !!this.payment) {
            customerName = this.payment.customer.displayName;
        } else if (this.type === 'Vendor') {
            customerName = this.vendor.displayName;
        }
        return customerName;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  customerId?: number;
  invoiceId?: number;
  message?: string;
  paymentId?: number;
  quickBooksTaskId!: number;
  status?: string;
  vendorId?: number;
  customer!: Customer;
  invoice!: Invoice;
  payment!: Payment;
  quickBooksTask!: QuickBooksTask;
  vendor!: Vendor;
}

